var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMinimize = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12.2 2.6"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.7 2.6H.5c-.3 0-.5-.2-.5-.5V.5C0 .2.2 0 .5 0h11.2c.3 0 .5.2.5.5v1.6c0 .3-.2.5-.5.5z"
})));
export default SvgIconMinimize;